import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ShippingAddress({ customer, sendShippingDetailsToParent }) {
  const [shippingDetails, setShippingDetails] = useState({
    firstname: customer.firstname,
    lastname: customer.lastname,
    address: customer.address,
    phoneNumber: customer.phoneNumber,
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const newShippingDetails = { ...shippingDetails };
    newShippingDetails[e.target.id] = e.target.value;
    setShippingDetails(newShippingDetails);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    sendShippingDetailsToParent(shippingDetails);
    navigate("/checkout/2");
  };

  return (
    <div className="mt-5 mb-5">
      <h2>Step 1</h2>
      <h3>Shipping Address</h3>
      <form onSubmit={handleSubmit} className="row g-3 mt-3">
        <div className="col-md-6">
          <label htmlFor="firstname" className="form-label">
            First Name
          </label>
          <input
            type="text"
            className="form-control"
            id="firstname"
            value={shippingDetails.firstname}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-6">
          <label htmlFor="lastname" className="form-label">
            Last Name
          </label>
          <input
            type="text"
            className="form-control"
            id="lastname"
            onChange={handleChange}
            value={shippingDetails.lastname}
          />
        </div>
        <div className="col-12">
          <label htmlFor="address" className="form-label">
            Address
          </label>
          <input
            type="text"
            className="form-control"
            id="address"
            onChange={handleChange}
            value={shippingDetails.address}
          />
        </div>

        <div className="col-md-6">
          <label htmlFor="phoneNumber" className="form-label">
            Phone Number
          </label>
          <input
            type="text"
            className="form-control"
            id="phoneNumber"
            onChange={handleChange}
            value={shippingDetails.phoneNumber}
          />
        </div>

        <div className="col-12">
          <button
            type="submit"
            className="btn btn-main rounded-pill border p-2 text-center confirm-button"
          >
            <i className="pe-2 fa-solid fa-arrow-right"></i>
            Continue
          </button>
        </div>
      </form>
    </div>
  );
}
